export class AuditFormsUserStatsDto {
  dueSoon?: number;
  adHoc?: number;
  started?: number;
  recentlyCompleted?: number;
}
